/**
 * Whether a resource currently reads as occupied for map-spot styling.
 *
 * Walk-up resources are occupied via an external check-in, not a booking
 * window — they can accumulate ordinary schedule records (past check-ins
 * that already have an end) without being occupied right now. Only a
 * schedule with no end yet means someone is actually there. Regular
 * resources keep the simple "has any schedule" check.
 */
export function hasActiveResourceSchedule(
  schedules: { end: string | null }[] | undefined,
  isWalkUp: boolean
): boolean {
  if (isWalkUp) {
    return schedules?.some((s) => !s.end) ?? false;
  }
  return (schedules?.length ?? 0) > 0;
}
